import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFloppyDiskIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	x: "0px",
	y: "0px",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n        .disk-icon-st0{fill:currentColor;}\n    "
	}), /* @__PURE__ */ _jsx("path", {
		className: "disk-icon-st0",
		d: "M12.0489 0.640625H2.2369C1.32929 0.640625 0.601562 1.37653 0.601562 2.27596V13.7233C0.601562 14.6227 1.32929 15.3586 2.2369 15.3586H13.6842C14.5837 15.3586 15.3196 14.6227 15.3196 13.7233V3.91129L12.0489 0.640625ZM13.6842 13.7233H2.2369V2.27596H11.3702L13.6842 4.58996V13.7233ZM7.96056 7.99963C6.60324 7.99963 5.50756 9.0953 5.50756 10.4526C5.50756 11.81 6.60324 12.9056 7.96056 12.9056C9.31789 12.9056 10.4136 11.81 10.4136 10.4526C10.4136 9.0953 9.31789 7.99963 7.96056 7.99963ZM3.05456 3.09363H10.4136V6.36429H3.05456V3.09363Z"
	})]
});
export default SvgFloppyDiskIcon;
